/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApplicationResponse } from './ApplicationResponse';
import {
    ApplicationResponseFromJSON,
    ApplicationResponseFromJSONTyped,
    ApplicationResponseToJSON,
    ApplicationResponseToJSONTyped,
} from './ApplicationResponse';
import type { PageModel } from './PageModel';
import {
    PageModelFromJSON,
    PageModelFromJSONTyped,
    PageModelToJSON,
    PageModelToJSONTyped,
} from './PageModel';

/**
 * 
 * @export
 * @interface ApplicationResponsePagedResult
 */
export interface ApplicationResponsePagedResult {
    /**
     * 
     * @type {PageModel}
     * @memberof ApplicationResponsePagedResult
     */
    pageInfo?: PageModel;
    /**
     * 
     * @type {Array<ApplicationResponse>}
     * @memberof ApplicationResponsePagedResult
     */
    data: Array<ApplicationResponse> | null;
}

/**
 * Check if a given object implements the ApplicationResponsePagedResult interface.
 */
export function instanceOfApplicationResponsePagedResult(value: object): value is ApplicationResponsePagedResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ApplicationResponsePagedResultFromJSON(json: any): ApplicationResponsePagedResult {
    return ApplicationResponsePagedResultFromJSONTyped(json, false);
}

export function ApplicationResponsePagedResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationResponsePagedResult {
    if (json == null) {
        return json;
    }
    return {
        
        'pageInfo': json['pageInfo'] == null ? undefined : PageModelFromJSON(json['pageInfo']),
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(ApplicationResponseFromJSON)),
    };
}

export function ApplicationResponsePagedResultToJSON(json: any): ApplicationResponsePagedResult {
    return ApplicationResponsePagedResultToJSONTyped(json, false);
}

export function ApplicationResponsePagedResultToJSONTyped(value?: ApplicationResponsePagedResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageInfo': PageModelToJSON(value['pageInfo']),
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(ApplicationResponseToJSON)),
    };
}

